/** Cart, checkout, shop chrome, navigation — merged into store_copy. */

export const STORE_UI_COPY_DEFAULTS = {
  // Shop page
  shop_search_placeholder: 'Search by product name or ID…',
  shop_search_button: 'Search',
  shop_loading_categories: 'Loading latest categories…',
  shop_catalog_error_title: 'Shop temporarily unavailable',
  shop_catalog_error_text: 'We could not load collections right now. Please try again — your orders and account are unaffected.',
  shop_catalog_retry: 'Try again',
  shop_whatsapp_button: 'WhatsApp us',
  shop_contact_button: 'Contact us',
  shop_catalog_empty_title: 'Collections coming soon',
  shop_catalog_empty_text: 'New designs are on the way. Message us on WhatsApp for custom orders or visit our exhibitions.',
  shop_category_desc_template: 'Browse {count} handcrafted design(s).',
  shop_category_desc_singular: 'Browse 1 handcrafted design.',
  shop_category_empty: 'Collection coming soon.',
  shop_category_count: '{count} design(s)',
  shop_category_count_singular: '1 design',
  shop_category_coming_soon: 'Coming soon',

  // Global nav (header)
  nav_home: 'Home',
  nav_shop: 'Shop',
  nav_exhibitions: 'Exhibitions',
  nav_about: 'About',
  nav_contact: 'Contact',
  nav_track_order: 'Track order',
  nav_search_placeholder: 'Search name or ID…',
  skip_to_main: 'Skip to main content',

  // Footer nav links
  footer_nav_home: 'Home',
  footer_nav_shop: 'Shop',
  footer_nav_search: 'Search products',
  footer_nav_blog: 'Styling ideas',
  footer_nav_track_order: 'Track order',
  footer_nav_wishlist: 'Wishlist',
  footer_nav_account: 'My account',
  footer_nav_sign_in: 'Sign in',
  footer_nav_shipping: 'Shipping',
  footer_nav_returns: 'Returns',
  footer_nav_privacy: 'Privacy',
  footer_tagline_fallback: 'Handcrafted Rakhi & Lumba',
  footer_location: 'India',
  footer_studio_maps: 'Open in Maps',
  footer_studio_instagram: 'Instagram',
  footer_studio_whatsapp: 'WhatsApp',

  // Shop nav menu
  shop_nav_browse_all: 'Browse all designs',
  shop_nav_view_all: 'View all',
  shop_nav_overview: 'Shop overview',
  shop_nav_mobile_browse: 'Browse collections',
  shop_nav_mobile_close: 'Close shop collections',
  shop_nav_all_collections: 'All collections',
  shop_nav_browse: 'Browse',

  // Cart page
  cart_item_singular: 'item',
  cart_item_plural: 'items',
  cart_item_count_aria: '{count} items in bag',
  cart_line_price_each: '{price} each',
  cart_line_in_stock: '{count} in stock',
  cart_line_quantity: 'Quantity',
  cart_line_total: 'Line total',
  cart_continue_shopping: 'Continue shopping',
  cart_checkout_button: 'Proceed to checkout',
  cart_empty_account_button: 'My account',
  cart_empty_track_button: 'Track order',
  cart_empty_shop_button: 'Shop collections',
  cart_summary_footnote_authed: 'Delivery fee is calculated at checkout based on your PIN code.',
  cart_summary_footnote_guest:
    'Sign in for saved addresses, or continue as guest — delivery fee is calculated at checkout.',
  cart_sign_in_nudge_before: 'Sign in',
  cart_sign_in_nudge_after: 'for saved addresses and order history.',
  cart_mobile_subtotal: 'Subtotal',
  cart_mobile_total_estimated: 'Est. total',
  cart_mobile_checkout: 'Checkout',
  cart_checkout_loading: 'Loading…',
  cart_personalization_title: 'Complete personalization before checkout',
  cart_personalization_lead: 'Open each product below to choose letters or customization options, then return to checkout.',

  // Cart drawer
  cart_drawer_title: 'Your bag ({count})',
  cart_drawer_empty_lead: 'Your bag is empty — explore our collections.',
  cart_drawer_shop_button: 'Shop collections',
  cart_drawer_checkout: 'Checkout',
  cart_drawer_view_bag: 'View full bag',
  cart_drawer_edit_bag: 'Edit items & delivery',
  cart_drawer_subtotal: 'Subtotal',
  cart_stock_sync_loading: 'Checking stock for your bag…',
  cart_sync_loading: 'Syncing your bag…',
  cart_server_sync_unavailable: 'Bag sync is temporarily unavailable — items stay on this device.',
  cart_config_error: 'Delivery estimate is temporarily unavailable.',
  cart_config_retry: 'Retry',

  // Checkout
  checkout_title: 'Checkout',
  checkout_lead: 'We ship across India. Enter your details and choose how to pay.',
  checkout_empty_view_bag: 'View bag',
  checkout_empty_shop: 'Shop collections',
  checkout_guest_note:
    'Already have an account? Sign in for saved addresses. You can also track orders or reset your password.',
  checkout_section_contact: 'Contact',
  checkout_section_notes: 'Order notes',
  checkout_section_address: 'Delivery address',
  checkout_pin_intro: 'Enter your PIN code first — we use it for delivery fee and estimated dispatch.',
  checkout_field_name: 'Full name',
  checkout_field_phone: 'Mobile number',
  checkout_field_phone_hint: 'For delivery updates',
  checkout_field_email: 'Email',
  checkout_field_pin: 'PIN code',
  checkout_pin_hint: '6-digit postal PIN',
  checkout_field_email_hint_guest: 'For order updates',
  checkout_field_city: 'City / district',
  checkout_field_state: 'State',
  checkout_field_state_placeholder: 'Select state',
  checkout_field_address: 'Street address',
  checkout_field_address_placeholder: 'House no., street, landmark',
  checkout_field_notes: 'Order notes (optional)',
  checkout_field_notes_placeholder: 'Gift message, delivery instructions…',
  checkout_saved_address_filled: 'Filled from your last order — edit if needed.',
  checkout_saved_address_using: 'Using saved address from your account.',
  checkout_pay_processing: 'Processing…',
  checkout_pay_online: 'Pay {total}',
  checkout_pay_offline: 'Place order · {total}',
  checkout_secure_online: 'Secure payment via Razorpay. Your card details are never stored on our site.',
  checkout_secure_offline: 'We will confirm your order and share payment instructions if needed.',
  checkout_pending_payment: 'Your order is saved — complete payment to confirm. Check your email or contact us.',
  checkout_payment_pending_banner:
    'Order #{order} is ready — tap Pay {total} below to finish. You will not be charged twice.',
  checkout_payment_retry:
    'Payment did not finish. Tap Pay {total} below to try again — you will not be charged twice.',
  checkout_payment_failed:
    'Payment failed. Tap Pay below to try again, or we will contact you with other payment options.',
  checkout_payment_not_opened:
    'Order #{order} was created but payment could not open. Tap Pay below to try again.',
  checkout_config_error: 'Checkout settings could not load. Delivery and payment options may be incomplete.',
  checkout_config_retry: 'Reload checkout',
  checkout_try_payment_again: 'Try payment again',
  checkout_try_place_again: 'Try again',
  track_order_error_generic: 'Could not look up your order. Please try again or message us on WhatsApp.',
  track_order_error_unavailable: 'Order lookup is temporarily unavailable. Please try again in a few minutes.',
  track_order_error_not_found: 'Order not found. Check your order number and the email or phone from checkout.',
  track_order_print_receipt: 'Print receipt',
  wishlist_sync_unavailable:
    'Account sync is temporarily unavailable. Items stay saved on this device until sync is restored.',
  pdp_share_copied: 'Link copied',
  pdp_sticky_oos_label: 'Out of stock',
  pdp_sticky_notify: 'Notify me',
  checkout_progress_cart: 'Cart',
  checkout_progress_details: 'Details',
  checkout_progress_payment: 'Payment',

  // Order summary panel
  order_summary_title: 'Order summary',
  order_summary_subtotal: 'Subtotal',
  order_summary_delivery: 'Delivery',
  order_summary_delivery_free: 'Free',
  order_summary_total: 'Total',
  order_summary_promo: 'Promo',
  order_summary_edit_bag: 'Edit bag',
  order_summary_qty: 'Qty',

  // Checkout confidence / extras
  checkout_back_to_bag: 'Back to bag',
  checkout_back_to_bag_hint: 'Review or edit your items',
  checkout_confidence_badge_empty: 'Your bag',
  checkout_confidence_badge_one: '1 item in bag',
  checkout_confidence_badge_many: '{count} items in bag',
  checkout_coupon_prompt: 'Have a promo code?',
  checkout_coupon_apply: 'Apply',
  checkout_coupon_applied: 'Promo applied',
  checkout_payment_options: 'Payment options',
  checkout_pay_online_method: 'Pay online now (UPI / card / netbanking)',
  checkout_pay_offline_method: 'Pay later (WhatsApp / bank transfer — we confirm your order)',
  checkout_confidence_items: '{count} items',

  // Free shipping nudge
  free_shipping_qualified: 'You qualify for free delivery on this order.',
  free_shipping_add_more: 'Add {amount} more for free delivery.',

  // Wishlist nudge
  wishlist_nudge_view: 'View saved items',
  wishlist_nudge_dismiss: 'Dismiss',
  wishlist_nudge_count_singular: '1 saved item',
  wishlist_nudge_count_plural: '{count} saved items',

  // Home microcopy
  home_assistant_eyebrow: 'Smart assistant',
  home_blog_card_eyebrow: 'Story',
  home_blog_read_label: 'Read article',
  home_merchandising_cta_fallback: 'Learn more',
  home_shelf_title_fallback: 'Featured',
  home_shelf_soon: 'Soon',
  home_catalog_error_title: 'Some products could not load',
  home_catalog_error_text: 'Pull down to refresh, or browse the shop. Your cart and account are unaffected.',
  home_catalog_retry: 'Refresh shop',
  home_shop_empty_title: 'Collections coming soon',
  home_shop_empty_text: 'New designs are being added. Message us on WhatsApp for custom orders or visit our exhibitions.',
  home_shop_empty_action: 'Browse shop',
  home_featured_empty_lead: 'Highlights are updating — explore the full shop below.',
  home_featured_empty_action: 'Shop all',

  // Search page
  search_title: 'Search the catalog',
  search_subtitle: 'Find pieces by name, product ID, or keywords.',
  search_placeholder: 'Product name or ID…',
  search_button: 'Search',
  search_hint: 'Enter a search term above to explore the catalog.',
  search_popular_heading: 'Popular searches',
  search_empty_title: 'No matches found',
  search_empty_text: 'Nothing matched “{query}”. Try another name, product ID, or browse our collections.',
  search_browse_button: 'Browse shop',
  search_whatsapp_button: 'WhatsApp us',
  exhibitions_error_title: 'Could not load the schedule',
  exhibitions_error_text: 'Please try again — or message us for upcoming show dates.',
  exhibitions_error_retry: 'Try again',
  home_exhibitions_error_text: 'Show schedule could not load right now.',
  home_exhibitions_error_link: 'View exhibitions',
  search_breadcrumb_home: 'Home',
  search_breadcrumb_shop: 'Shop',
  search_breadcrumb_search: 'Search',
  policy_page_print_button: 'Print policy',
  wishlist_add_all_button: 'Add all to bag',
  wishlist_add_all_done: '{count} items added to your bag.',
  wishlist_add_all_partial: '{added} added — {skipped} need options or are out of stock.',
  wishlist_add_all_none: 'Nothing could be added. Open each piece to choose options or check stock.',
  wishlist_view_bag_button: 'View your bag',
  gift_finder_catalog_error: 'We could not load products for the gift finder.',
  gift_finder_catalog_retry: 'Try again',
  search_catalog_error_title: 'Search unavailable',
  search_catalog_error_text: 'We could not load the catalog. Try again or browse collections.',
  collection_empty_title: 'No products here yet',
  collection_empty_text: 'Please check back soon for new arrivals in this style.',
  collection_hub_empty_title: 'This collection is growing',
  collection_hub_empty_text: 'New pieces are added often. Browse the full shop or message us for a custom order.',
  pdp_not_found_retry: 'Refresh catalog',
  pdp_notify_email_label: 'Email for back-in-stock alert',
  product_reviews_load_error: 'Could not load reviews.',
  product_reviews_retry: 'Try again',
  account_orders_retry: 'Try again',
  account_address_retry: 'Try again',
  order_invoice_loading: 'Loading receipt…',
  order_invoice_retry: 'Try again',
  payment_status_updating: 'Payment details are updating — refresh in a moment or use the payment ID on your receipt.',

  // Cart drawer
  cart_drawer_personalization_lead: 'Complete personalization on the product page before checkout.',
  cart_drawer_fix_on_cart: 'Review bag',

  // Pull to refresh (mobile home)
  pull_refresh_pull: 'Pull to refresh',
  pull_refresh_release: 'Release to refresh',
  pull_refresh_refreshing: 'Refreshing…',

  // Order success
  order_success_view_details: 'View order details',
  order_success_track_prefilled: 'Track with saved email',
  order_success_no_email_hint: 'Did not get a confirmation email? Use Track order with your checkout email or phone.',
  order_success_contact_email: 'Email us about this order',

  // Blog
  blog_empty_title: 'Stories coming soon',
  blog_empty_text: 'We are preparing styling tips and gift guides. Browse the shop or message us on WhatsApp in the meantime.',
  blog_empty_shop_button: 'Browse shop',
  blog_empty_contact_button: 'Contact us',

  // Wishlist
  wishlist_update_error: 'Could not update saved items. Please try again.',

  // Custom jewelry draft
  custom_jewelry_draft_restored: 'We restored your saved draft from this device.',
  custom_jewelry_draft_saved: 'Draft saved on this device.',
  custom_jewelry_draft_clear: 'Clear draft',
};
